/** CMS microcopy set `mini-cart`, with the English defaults. */
export const MINI_CART_MICROCOPY_SET = 'mini-cart';

export const MINI_CART_MICROCOPY_DEFAULTS = {
  'mini-cart.title': 'Cart',
  'mini-cart.close': 'Close cart',
  'mini-cart.loading': 'Loading your cart',
  'mini-cart.error-title': 'Unable to load your cart',
  'mini-cart.error-description': 'Please try again.',
  'mini-cart.retry': 'Try again',
  'mini-cart.reload': 'Reload page',
  'mini-cart.empty-title': 'Your cart is empty',
  'mini-cart.empty-description':
    'Products added to the cart will show up here.',
};
